const priceData = [
  {
    name: "Free",
    description: "Great for occasional prospecting.",
    price: "$0",
    billed: "*billed at $0 per year.",
    features: [
      "20 emails per month",
      "5 phone numbers per month",
      "CRM Integration (not included)",
    ],
    highlight: false,
  },
  {
    name: "Email",
    description: "For those looking for just email data.",
    price: "$83",
    billed: "*billed at $990 per year.",
    features: [
      "Unlimited emails",
      "$0.35 per phone number",
      "10k/mo export limit",
      "CRM Integration",
    ],
    highlight: true,
  },
  {
    name: "Email + Phone",
    description: "For those that hit the phones!",
    price: "$166",
    billed: "*billed at $1990 per year.",
    features: [
      "Unlimited emails",
      "Unlimited phone numbers",
      "10k/mo export limit",
      "CRM Integration",
    ],
    highlight: false,
  },
];

export default priceData;
